// Quote
export { default as Quote } from "./Quote";
export type { default as QuoteProps } from "./QuoteProps.interface";